import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { CalendarClock, Check } from 'lucide-react';
import { Card } from '@/components/ui/card';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
const todaySast = () => new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Johannesburg' });

// Child-linked diary entries — same records as the main Diary (no copies).
export default function ChildDiaryCard({ childId }) {
  const [items, setItems] = useState([]);

  const load = () => axios.get(`${API}/reminders`, { ...auth(), params: { status: 'all', child_id: childId } })
    .then((r) => setItems(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, [childId]); // eslint-disable-line react-hooks/exhaustive-deps

  const toggle = async (r) => {
    await axios.put(`${API}/reminders/${r.id}`, { completed: !r.completed }, auth());
    load();
  };

  if (!items.length) return null;
  const t = todaySast();
  const open = items.filter((r) => !r.completed);
  const done = items.filter((r) => r.completed).slice(0, 5);

  return (
    <Card className="p-4" data-testid="child-diary-card">
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-medium text-stone-900 flex items-center gap-2"><CalendarClock className="w-4 h-4 text-[#7C6F9C]" /> Diary</h3>
        <Link to="/diary" className="text-xs text-[#7C6F9C] hover:underline" data-testid="child-diary-open-link">Open diary</Link>
      </div>
      {[...open, ...done].map((r) => {
        const overdue = !r.completed && r.date < t;
        return (
          <div key={r.id} className="flex items-center gap-2 py-1.5 border-b border-stone-100 last:border-b-0" data-testid={`child-diary-row-${r.id}`}>
            <button
              onClick={() => toggle(r)}
              className={`w-5 h-5 rounded border flex items-center justify-center ${r.completed ? 'bg-emerald-500 border-emerald-500 text-white' : 'border-stone-300'}`}
              aria-label="Toggle complete"
              data-testid={`child-diary-toggle-${r.id}`}
            >
              {r.completed && <Check className="w-3 h-3" />}
            </button>
            <Link to={`/diary?entry=${r.id}`} className="flex-1 min-w-0">
              <div className={`text-sm ${r.completed ? 'line-through text-stone-400' : 'text-stone-900'}`}>{r.title}</div>
              <div className="text-[11px] text-stone-500">
                {r.date}{r.time && ` · ${r.time}`}
                {overdue && <span className="ml-1 text-rose-600" data-testid={`child-diary-overdue-${r.id}`}>· Overdue</span>}
              </div>
            </Link>
          </div>
        );
      })}
    </Card>
  );
}
